<template>
    <div class="btn-group">
        <label
            v-for="(button, indexOrKey) in buttons"
            :key="'button' + indexOrKey"
            class="btn input-gray"
            :class="{ active: value === button.value, [button.value]: true }"
        >
            <slot :name="button.value" :item="button">
                {{ button.text }}
            </slot>

            <input
                type="radio"
                :checked="value === button.value"
                :name="name"
                :id="button.id || (name || 'id') + indexOrKey"
                class="d-none"
                :value="button.value"
                @change="$emit('update:value', button.value)"
                :required="required"
            />
        </label>
    </div>
</template>

<script>
export default {
    name: 'ButtonGroup',
    props: {
        buttons: [Array, Object],
        name: String,
        value: String,
        required: Boolean
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/theming' as *;
@use 'sass:map';

.btn-group {
    label.btn {
        &.active {
            color: var(--body-color);
            border-color: map.get(variables.$inputs, 'filled-color');
        }
    }
}
</style>
